import React from 'react';
import { GenericLogo } from '../CardLogo/CardLogoSet';
import {
  AffirmLogo,
  AfterpayLogo,
  KlarnaLogo,
  ApplePayLogo,
  GooglePayLogo,
  LinkLogo,
} from './StripeLogoSet';
import AmazonPayLogo from '../AmazonPayLogo';

export type StripeLogoProps = {
  stripeMethodType?: string;
  className?: string;
};

const renderLogo = (stripeMethodType?: string): React.ReactNode => {
  const normalizedStripeName = stripeMethodType
    ?.toLowerCase()
    .replace(/\s/gm, '');
  switch (normalizedStripeName) {
    case 'klarna':
      return <KlarnaLogo />;
    case 'afterpay_clearpay':
      return <AfterpayLogo />;
    case 'affirm':
      return <AffirmLogo />;
    case 'apple_pay':
      return (
        <div style={{ marginTop: '-10px', marginBottom: '-20px' }}>
          <ApplePayLogo />
        </div>
      );
    case 'google_pay':
      return (
        <div style={{ marginTop: '10px', marginBottom: '-5px' }}>
          <GooglePayLogo />
        </div>
      );
    case 'link':
      return <LinkLogo />;
    case 'amazon_pay':
      return <AmazonPayLogo />;
    default:
      return <GenericLogo />;
  }
};

const StripeLogo: React.FC<StripeLogoProps> = ({
  stripeMethodType,
  className = '',
}: StripeLogoProps) => {
  return (
    <div className={`${className} pointer-events-none`}>
      {renderLogo(stripeMethodType)}
    </div>
  );
};

export default StripeLogo;
